<template>
    <div class="detail-row-container"
         :class="{'selectable': selectable, 'selected': selected, indented: indented}"
         @click="onClick">
        <div>
            <i v-if="expanded !== null"
               class="fa fa-angle-right expansion-icon"
               :class="{expanded: this.expanded}"
               @click.prevent.stop="onExpand"/>
            <span>
        {{ statTitle }}
      </span>
        </div>
        <template v-if="!showPastComp">
            <div>
                {{ statValueText }}
            </div>
            <md-hover-button class="info-button" v-if="helperText" icon="fa-info" :align-y="helperTextAlignment">
                <div class="hover-text-container">
                    {{ helperText }}
                </div>
            </md-hover-button>
        </template>
        <template v-else>
            <div>
                {{ pastValueText }}
            </div>
            <div>
                {{ statValueText }}
            </div>
            <i class="comparison-icon"
               :class="comparisonIcon.icon"
               :style="{color: comparisonIcon.color, transform: `rotate(${comparisonIcon.rotation})`}"></i>
        </template>
    </div>
</template>

<script>
import { getChartArrow } from './pdhelper';

export default {
    name: 'DetailRow',
    props: {
        statKey: String,
        statValue: {
            type: [ Number, String ],
        },
        pastStatValue: {
            type: [ Number, String ],
        },
        showPastComp: Boolean,
        statTitle: String,
        isPercentage: Boolean,
        roundTo: {
            type: Number,
            default: 0,
        },
        prefix: String,
        postfix: String,
        helperText: {
            type: String,
            default: null,
        },
        helperTextAlignment: {
            type: String,
            default: 'bottom',
        },
        selectable: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: null,
        },
        indented: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        statValueText() {
            return this.valueToString(this.statValue);
        },
        pastValueText() {
            return this.valueToString(this.pastStatValue);
        },
        comparisonIcon() {
            const currentVal = this.statValue;
            const pastVal = this.pastStatValue;
            if (currentVal === null || isNaN(currentVal) || pastVal === null || isNaN(pastVal)) {
                return { color: 'var(--contrast-3)', rotation: '0', icon: 'fas fa-minus-circle' };
            } else {
                const divisor = 100 / Math.pow(10, this.roundTo); // This could be an issue with different values
                return getChartArrow(this.isPercentage ? currentVal - pastVal : currentVal / divisor - pastVal / divisor);
            }
        },
    },
    methods: {
        onClick() {
            if (this.selectable)
                this.$emit('statSelect', this.statKey);
        },
        onExpand() {
            this.$emit('expand', this.statKey);
        },
        valueToString(val) {
            if (typeof val === 'string' && val !== '--')
                return ( this.prefix || '' ) + val + ( this.postfix || '' );
            if (val === null || isNaN(val) || val === '--')
                return '--';
            if (this.isPercentage)
                return `${this.prefix || ''}${( val * 100 ).toFixed(this.roundTo)}${this.postfix || '%'}`;
            return ( this.prefix || '' ) + val.toFixed(this.roundTo) + ( this.postfix || '' );
        },
    },
}
</script>

<style scoped>
.detail-row-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 0.75rem;
    align-items: center;
    color: var(--contrast-4);
    text-align: left;
    font-size: 0.9rem;
    margin: 0.125rem 0;
    padding: 0.125rem 0;
}

.detail-row-container.indented {
    padding-left: 1rem;
}

.detail-row-container > div {
    flex: 1;
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.5rem;
    text-align: right;
}

.detail-row-container.selectable > div, .detail-row-container.selectable > div > span {
    cursor: pointer;
}

.detail-row-container > :first-child {
    text-align: left;
    flex: 2;
    justify-content: flex-start;
}

.detail-row-container > .info-button {
    flex: 0;
}

.selected {
    font-weight: bold;
    color: var(--contrast-4);
}

.hover-text-container {
    max-width: 440px;
    font-weight: normal;
    text-align: left;
}

.expansion-icon {
    padding: 0.25rem 0;
    font-size: 0.75rem;
    color: var(--contrast-4);
    cursor: pointer;
    transform: rotate(0);
    transition: transform 250ms ease-in-out;
}

.expansion-icon.expanded {
    transform: rotate(90deg);
}

.comparison-icon {
    padding: 1px;
}
</style>

<style>
.detail-row-container .hover-button-content {
    outline: 0.25rem solid var(--contrast-3);
}
</style>
